import InfoMessage from "@components-shared/InfoMessageComponent";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import { getLoginReturnUrl } from "@utils/auth";
import { MobilePlatform } from "@state/stores/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function FavoritePopup(props: { isOpened?: boolean }) {
	const { t } = useTranslation();
	const rootStore = useRootAppStore<MobilePlatform>();

	useFixBody(true, props.isOpened);

	return (
		<div className="at-addToFavsPopup popup">
			<div className="popup__card">
				<div className="popup__header">
					<div className="popup__title">
						{t("FAVORITES.PAGE.TITLE")}
					</div>
					<button
						type="button"
						onClick={rootStore.favoritePopupStore.deactivatePopup}
						className="popup__close btn btn--square btn--square--sml btn--ghost"
					>
						<i className="btn__icon u-icon u-icon--tny u-icon--close u-color--text--secondary" />
					</button>
				</div>
				<div className="popup__body">
					<InfoMessage
						type="note"
						message={t("FAVORITES.NONAUTH_TOOLTIP")}
					/>
				</div>
				<div className="popup__footer">
					<Link
						to={getLoginReturnUrl()}
						onClick={rootStore.favoritePopupStore.deactivatePopup}
						className="popup__btn popup__btn--primary btn btn--med btn--block btn--accent"
					>
						{t("COMMON.LOGIN_TITLE")}
					</Link>
				</div>
			</div>
		</div>
	);
}
